export enum ErrorChannelEnum {
  UI = "ui",
  ROUTE = "route",
  ACTION = "action",
  PROXY = "proxy",
  CLIENT_QUERY = "client-query",
  UNKNOWN = "unknown",
}

export enum ErrorOriginEnum {
  APP = "app",
  SUPABASE = "supabase",
  HTTP = "http",
  JS = "js",
  UNKNOWN = "unknown",
}

// Server-action error codes. Stable identifiers thrown by `src/app/actions/**`
// and recognized at the UI boundary for localized error messages.
export enum ActionErrorCodeEnum {
  FORBIDDEN = "forbidden",
  MERCHANT_REQUIRED = "merchant_required",
  INVALID_DELTA = "invalid_delta",
  INVALID_INPUT = "invalid_input",
  NOT_FOUND = "not_found",
  CONFLICT_DUPLICATE_EMAIL = "conflict_duplicate_email",
  PROFILE_NOT_FOUND = "profile_not_found",
  MERCHANT_NOT_FOUND = "merchant_not_found",
  USER_NOT_FOUND = "user_not_found",
  SUPABASE_ERROR = "supabase_error",
}
